(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-split-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-split-banner')) {
    class EditorialSplitBanner extends HTMLElement {
      connectedCallback() {
        this.disconnectObserver();
        this.removeInteractionListeners();
        this.removeLayoutListener();

        this.layoutQuery = window.matchMedia('(max-width: 749px)');
        this.onLayoutChange = () => this.syncDomOrder();
        this.layoutQuery.addEventListener('change', this.onLayoutChange);
        this.syncDomOrder();

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        this.classList.add('is-animation-ready');
        this.onBlockSelect = () => this.reveal(true);
        this.onFocusIn = () => this.reveal(true);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('focusin', this.onFocusIn);
        if (this.contains(document.activeElement)) {
          this.reveal(true);
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.reveal();
            }
          },
          { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
        );

        requestAnimationFrame(() => {
          if (this.isConnected && this.observer) {
            this.observer.observe(this);
          }
        });
      }

      disconnectedCallback() {
        this.disconnectObserver();
        this.removeInteractionListeners();
        this.removeLayoutListener();
      }

      reveal(immediate = false) {
        if (immediate) {
          this.classList.add('is-reveal-immediate');
        }
        this.classList.add('is-visible');
        this.disconnectObserver();
      }

      disconnectObserver() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }

      removeInteractionListeners() {
        if (this.onBlockSelect) {
          this.removeEventListener('shopify:block:select', this.onBlockSelect);
          this.onBlockSelect = null;
        }
        if (this.onFocusIn) {
          this.removeEventListener('focusin', this.onFocusIn);
          this.onFocusIn = null;
        }
      }

      syncDomOrder() {
        const inner = this.querySelector('.editorial-split-banner__inner');
        const content = this.querySelector('.editorial-split-banner__content');
        const media = this.querySelector('.editorial-split-banner__media-grid');
        if (!inner || !content || !media || !this.layoutQuery) return;

        const preferredOrder = this.layoutQuery.matches ? this.dataset.mobileOrder : this.dataset.desktopLayout;
        const firstElement = preferredOrder === 'image_first' ? media : content;
        const secondElement = preferredOrder === 'image_first' ? content : media;
        if (inner.firstElementChild !== firstElement) {
          const focusedElement = this.contains(document.activeElement) ? document.activeElement : null;
          if (typeof inner.moveBefore === 'function') {
            inner.moveBefore(firstElement, secondElement);
          } else {
            inner.insertBefore(firstElement, secondElement);
          }
          if (focusedElement && document.activeElement !== focusedElement) {
            focusedElement.focus({ preventScroll: true });
          }
        }
      }

      removeLayoutListener() {
        if (this.layoutQuery && this.onLayoutChange) {
          this.layoutQuery.removeEventListener('change', this.onLayoutChange);
        }
        this.layoutQuery = null;
        this.onLayoutChange = null;
      }
    }

    customElements.define('editorial-split-banner', EditorialSplitBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technical-resources"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('technical-resources')) {
    class TechnicalResources extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        this.tabs = Array.from(this.querySelectorAll('[data-resource-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-resource-panel]'));
        this.tablist = this.querySelector('[data-resource-tablist]');
        this.searchInput = this.querySelector('[data-resource-search-input]');
        this.status = this.querySelector('[data-resource-status]');
        this.singularLabel = this.dataset.singularLabel || '';
        this.pluralLabel = this.dataset.pluralLabel || '';

        this.addEventListener('click', this.handleClick.bind(this), { signal: this.controller.signal });
        this.addEventListener('keydown', this.handleKeydown.bind(this), { signal: this.controller.signal });
        this.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this), { signal: this.controller.signal });

        if (this.searchInput) {
          this.searchInput.addEventListener('input', () => this.filterActivePanel(), { signal: this.controller.signal });
        }

        if (this.tabs.length > 0 && this.tablist) {
          this.enhanceTabs();
        }
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.initialized = false;
      }

      enhanceTabs() {
        this.classList.add('technical-resources--enhanced');
        this.tablist.setAttribute('role', 'tablist');
        this.tablist.setAttribute('aria-orientation', 'horizontal');

        this.tabs.forEach((tab) => {
          const panelId = tab.getAttribute('href').slice(1);
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panelId);
          tab.setAttribute('aria-selected', 'false');
          tab.setAttribute('tabindex', '-1');
        });

        this.panels.forEach((panel) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('tabindex', '0');
        });

        const defaultTab = this.tabs.find((tab) => tab.hasAttribute('data-default-tab')) || this.tabs[0];
        this.activateTab(defaultTab, false);
      }

      handleClick(event) {
        const tab = event.target.closest('[data-resource-tab]');
        if (tab && this.contains(tab)) {
          event.preventDefault();
          this.activateTab(tab, true);
        }
      }

      handleKeydown(event) {
        const currentTab = event.target.closest('[data-resource-tab]');
        if (!currentTab || !this.contains(currentTab)) return;

        const currentIndex = this.tabs.indexOf(currentTab);
        const rtl = document.documentElement.dir === 'rtl';
        let nextIndex = null;

        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (event.key === 'ArrowRight') nextIndex = rtl ? currentIndex - 1 : currentIndex + 1;
        if (event.key === 'ArrowLeft') nextIndex = rtl ? currentIndex + 1 : currentIndex - 1;

        if (nextIndex === null) return;
        event.preventDefault();
        nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
        this.tabs[nextIndex].focus();
        this.activateTab(this.tabs[nextIndex], true);
      }

      activateTab(tab, animate) {
        if (!tab) return;
        const category = tab.dataset.resourceCategory;

        const update = () => {
          this.tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.setAttribute('tabindex', selected ? '0' : '-1');
          });

          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.resourceCategory !== category;
          });

          this.activeTab = tab;
          this.filterActivePanel();
        };

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (animate && document.startViewTransition && !reduceMotion) {
          document.startViewTransition(update);
        } else {
          update();
        }
      }

      filterActivePanel() {
        const activePanel = this.panels.find((panel) => !panel.hidden);
        if (!activePanel) return;
        const query = (this.searchInput ? this.searchInput.value : '').trim().toLocaleLowerCase();
        const cards = Array.from(activePanel.querySelectorAll('[data-resource-card]'));
        let visibleCount = 0;

        cards.forEach((card) => {
          const matches = !query || (card.dataset.resourceSearch || '').includes(query);
          card.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        const noResults = activePanel.querySelector('[data-resource-no-results]');
        if (noResults) noResults.hidden = visibleCount > 0;
        if (this.status) {
          const label = visibleCount === 1 ? this.singularLabel : this.pluralLabel;
          this.status.textContent = `${visibleCount} ${label}`.trim();
        }
      }

      handleBlockSelect(event) {
        const card = event.target.closest('[data-resource-card]');
        if (!card || !this.contains(card)) return;
        if (this.searchInput) this.searchInput.value = '';
        const category = card.dataset.resourceCategory;
        const tab = this.tabs.find((item) => item.dataset.resourceCategory === category);
        if (tab) this.activateTab(tab, false);
        card.hidden = false;
        window.requestAnimationFrame(() => card.scrollIntoView({ block: 'center' }));
      }
    }

    customElements.define('technical-resources', TechnicalResources);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nibbi-video-showcase')) {
    class NibbiVideoShowcase extends HTMLElement {
      connectedCallback() {
        if (this.isConnectedAndInitialized) return;
        this.isConnectedAndInitialized = true;

        this.track = this.querySelector('.nibbi-video-showcase__track');
        this.cards = this.track ? Array.from(this.track.querySelectorAll('.nibbi-video-showcase__card')) : [];
        this.previousButton = this.querySelector('.nibbi-video-showcase__prev');
        this.nextButton = this.querySelector('.nibbi-video-showcase__next');
        this.animationTarget = this.querySelector('.nibbi-video-showcase__inner');

        if (!this.modal) {
          this.modal = this.querySelector('.nibbi-video-showcase__modal');
          this.dialog = this.modal ? this.modal.querySelector('.nibbi-video-showcase__dialog') : null;
          this.modalFrame = this.modal ? this.modal.querySelector('[data-modal-frame]') : null;
        }

        if (this.modal && this.modal.parentNode !== document.body) {
          document.body.appendChild(this.modal);
        }

        this.classList.add('is-initialized');

        this.onRootClickBound = this.onRootClick.bind(this);
        this.onModalClickBound = this.onModalClick.bind(this);
        this.onModalCancelBound = this.onModalCancel.bind(this);
        this.onTrackScrollBound = this.scheduleNavigationUpdate.bind(this);
        this.onResizeBound = this.scheduleNavigationUpdate.bind(this);
        this.onBlockSelectBound = this.onBlockSelect.bind(this);

        this.addEventListener('click', this.onRootClickBound);
        if (this.modal) {
          this.modal.addEventListener('click', this.onModalClickBound);
          this.modal.addEventListener('cancel', this.onModalCancelBound);
        }
        if (this.track) this.track.addEventListener('scroll', this.onTrackScrollBound, { passive: true });
        document.addEventListener('shopify:block:select', this.onBlockSelectBound);

        if (this.track && 'ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResizeBound);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', this.onResizeBound, { passive: true });
        }

        this.setupAnimation();
        this.scheduleNavigationUpdate();
      }

      disconnectedCallback() {
        if (!this.isConnectedAndInitialized) return;
        this.closeModal(false);
        this.removeEventListener('click', this.onRootClickBound);
        if (this.modal) {
          this.modal.removeEventListener('click', this.onModalClickBound);
          this.modal.removeEventListener('cancel', this.onModalCancelBound);
        }
        if (this.track) this.track.removeEventListener('scroll', this.onTrackScrollBound);
        document.removeEventListener('shopify:block:select', this.onBlockSelectBound);

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        } else {
          window.removeEventListener('resize', this.onResizeBound);
        }

        if (this.animationObserver) {
          this.animationObserver.disconnect();
          this.animationObserver = null;
        }

        ['navigationFrame', 'focusFrame', 'restoreFocusFrame'].forEach((frameName) => {
          if (!this[frameName]) return;
          cancelAnimationFrame(this[frameName]);
          this[frameName] = null;
        });

        if (this.modal && this.modal.parentNode) this.modal.parentNode.removeChild(this.modal);
        this.classList.remove('is-initialized');
        this.isConnectedAndInitialized = false;
      }

      onRootClick(event) {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest('[data-video-trigger]');
        if (trigger && this.contains(trigger)) {
          this.openModal(trigger);
          return;
        }

        const navigationButton = event.target.closest('[data-slider-direction]');
        if (navigationButton && this.contains(navigationButton)) {
          this.scrollSlider(Number(navigationButton.dataset.sliderDirection));
        }
      }

      onModalClick(event) {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('[data-modal-close]') || event.target === this.modal) {
          this.closeModal(true);
        }
      }

      onModalCancel(event) {
        event.preventDefault();
        this.closeModal(true);
      }

      scheduleNavigationUpdate() {
        if (this.navigationFrame) return;
        this.navigationFrame = requestAnimationFrame(() => {
          this.navigationFrame = null;
          this.updateNavigation();
        });
      }

      scrollSlider(direction) {
        if (!this.track || !this.cards.length) return;
        const firstCard = this.cards[0];
        const trackStyles = window.getComputedStyle(this.track);
        const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
        const isRtl = trackStyles.direction === 'rtl';
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const distance = (firstCard.getBoundingClientRect().width + gap) * direction * (isRtl ? -1 : 1);

        this.track.scrollBy({
          left: distance,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      updateNavigation() {
        if (!this.track || !this.cards.length || !this.previousButton || !this.nextButton) return;

        const trackRect = this.track.getBoundingClientRect();
        const firstRect = this.cards[0].getBoundingClientRect();
        const lastRect = this.cards[this.cards.length - 1].getBoundingClientRect();
        const isRtl = window.getComputedStyle(this.track).direction === 'rtl';
        const tolerance = 2;
        const atStart = isRtl
          ? firstRect.right <= trackRect.right + tolerance
          : firstRect.left >= trackRect.left - tolerance;
        const atEnd = isRtl
          ? lastRect.left >= trackRect.left - tolerance
          : lastRect.right <= trackRect.right + tolerance;

        this.previousButton.disabled = atStart;
        this.nextButton.disabled = atEnd;
      }

      openModal(trigger) {
        if (!this.modal || !this.dialog || !this.modalFrame) return;
        const videoId = trigger.dataset.videoId || '';
        if (!/^[A-Za-z0-9_-]{6,20}$/.test(videoId)) return;

        const label = trigger.dataset.videoLabel || 'YouTube video';
        const iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0&playsinline=1';
        iframe.title = label;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.loading = 'eager';
        iframe.setAttribute('allowfullscreen', '');

        if (this.restoreFocusFrame) {
          cancelAnimationFrame(this.restoreFocusFrame);
          this.restoreFocusFrame = null;
        }

        this.modalFrame.replaceChildren(iframe);
        this.modal.setAttribute('aria-label', label);
        this.lastTrigger = trigger;

        if (!this.modal.open) {
          if (typeof this.modal.showModal === 'function') {
            this.modal.showModal();
          } else {
            this.modal.setAttribute('open', '');
          }
        }
        this.modal.classList.add('is-open');

        if (!this.modalIsOpen) {
          this.modalIsOpen = true;
          this.lockDocumentScroll();
        }

        if (this.focusFrame) cancelAnimationFrame(this.focusFrame);
        this.focusFrame = requestAnimationFrame(() => {
          this.focusFrame = null;
          if (!this.modalIsOpen) return;
          try {
            this.dialog.focus({ preventScroll: true });
          } catch (error) {
            this.dialog.focus();
          }
        });
      }

      closeModal(restoreFocus) {
        if (!this.modal || !this.modalFrame) return;

        if (this.focusFrame) {
          cancelAnimationFrame(this.focusFrame);
          this.focusFrame = null;
        }

        this.modalFrame.replaceChildren();
        this.modal.classList.remove('is-open');

        if (this.modal.open) {
          if (typeof this.modal.close === 'function') {
            try {
              this.modal.close();
            } catch (error) {
              this.modal.removeAttribute('open');
            }
          } else {
            this.modal.removeAttribute('open');
          }
        }

        if (this.modalIsOpen) {
          this.modalIsOpen = false;
          this.unlockDocumentScroll();
        }

        if (restoreFocus && this.lastTrigger && document.contains(this.lastTrigger)) {
          const target = this.lastTrigger;
          if (this.restoreFocusFrame) cancelAnimationFrame(this.restoreFocusFrame);
          this.restoreFocusFrame = requestAnimationFrame(() => {
            this.restoreFocusFrame = null;
            if (!document.contains(target)) return;
            try {
              target.focus({ preventScroll: true });
            } catch (error) {
              target.focus();
            }
          });
        }
      }

      lockDocumentScroll() {
        if (this.hasDocumentLock) return;
        this.hasDocumentLock = true;
        NibbiVideoShowcase.activeDocumentLocks += 1;

        if (NibbiVideoShowcase.activeDocumentLocks === 1) {
          document.body.classList.add('nibbi-video-showcase-lock');
          document.documentElement.classList.add('nibbi-video-showcase-lock');
        }
      }

      unlockDocumentScroll() {
        if (!this.hasDocumentLock) return;
        this.hasDocumentLock = false;
        NibbiVideoShowcase.activeDocumentLocks = Math.max(0, NibbiVideoShowcase.activeDocumentLocks - 1);

        if (NibbiVideoShowcase.activeDocumentLocks === 0) {
          document.body.classList.remove('nibbi-video-showcase-lock');
          document.documentElement.classList.remove('nibbi-video-showcase-lock');
        }
      }

      setupAnimation() {
        if (!this.animationTarget) return;
        const shouldAnimate = this.dataset.enableAnimation === 'true';
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!shouldAnimate || reducedMotion || !('IntersectionObserver' in window)) {
          this.animationTarget.classList.add('is-animation-visible');
          return;
        }

        this.animationTarget.classList.add('is-animation-pending');
        this.animationObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.remove('is-animation-pending');
            entry.target.classList.add('is-animation-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
        this.animationObserver.observe(this.animationTarget);
      }

      onBlockSelect(event) {
        if (!(event.target instanceof Element) || !this.contains(event.target)) return;
        const card = event.target.closest('.nibbi-video-showcase__card');
        if (!card) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        card.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }

    NibbiVideoShowcase.activeDocumentLocks = 0;
    customElements.define('nibbi-video-showcase', NibbiVideoShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
